import { FarmImport } from './Imports'
const { RoutesMap, FarmList, FarmCropDetails, DailyLogs, ServiceRequestList, FarmExpenseList, DailyLogList, DailylogDetails } = FarmImport

const FarmRoute = () => {
    return [
        {
            path: RoutesMap.FARM_LIST.path,
            element: <FarmList />
        },

        {
            path: RoutesMap.FARM_CROP_DETAILS.path,
            element: <FarmCropDetails />
        },

        {
            path: RoutesMap.DAILY_LOGS.path,
            element: <DailyLogList />
        },
        {
            path: RoutesMap.DAILY_LOG_DETAILS.path,
            element: <DailylogDetails />
        },
        {
            path: RoutesMap.ADD_DAILY_LOG.path,
            element: <DailyLogs />
        },
        {
            path: RoutesMap.SERVICE_REQUEST_LIST.path,
            element: <ServiceRequestList />
        },

        {
            path: RoutesMap.FARM_EXPENSE_LIST.path,
            element: <FarmExpenseList />
        },
    ]
}

export default FarmRoute;